
import { serverDataContext as context } from '@xingternal/crate-core-global-contexts';

context.displayName = 'Hops.ServerData';

export default context;
export const Consumer = context.Consumer;
export const Provider = context.Provider;
